import { render, staticRenderFns } from "./NcGuidedTextarea.vue?vue&type=template&id=32601e87&scoped=true"
import script from "./NcGuidedTextarea.vue?vue&type=script&lang=js"
export * from "./NcGuidedTextarea.vue?vue&type=script&lang=js"
import style0 from "./NcGuidedTextarea.vue?vue&type=style&index=0&id=32601e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32601e87",
  null
  
)

export default component.exports